import { IRoster } from '../roster/roster.models';

import { IDisplayInfo, ITeamInfo, PositionalTypes } from './event-tree.class';
import { IEventTreeStateModel } from './event-tree.model';

export const eventTreeStateDefaults: IEventTreeStateModel = {
    eventTreeInstance: undefined,
    selectedMatrixItem: undefined,
    error: undefined,
};

export const getTeamAndPlayersInfo = (teamId: string, roster: IRoster): ITeamInfo => ({
    teamId,
    players: (roster.teams[teamId]?.players ?? []).map(player => ({
        playerId: player.id,
        position: player.position ?? '',
        number: player.jerseyNum ? parseInt(player.jerseyNum, 10) : -1,
    })),
});

/**
 * True while the engine is showing recommended next events
 * (`displayInfo.location.type === 'INextEvent'`).
 * @param info
 * @returns
 */
export const isRecommendedEventTreeState = (eventTreeDisplayInfo: IDisplayInfo | undefined | null): boolean =>
    eventTreeDisplayInfo?.location?.type === PositionalTypes.Recommended;
